import { MenuContext, menuContext } from '../context'
import { useContext } from 'react'

export const useMenuContext = (): MenuContext => {
  const context = useContext(menuContext)
  if (!context) {
    throw new Error('useMenuContext must be called within the scope of a MenuProvider')
  }
  return context
}
